import React from 'react';
import AuthService from '../../Services/AuthService';
import Grid from '@material-ui/core/Grid';
import Event from './UserEvent';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';
import styles from './Styles';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Table } from 'material-ui';

class EventList extends React.Component {
  constructor(props) {
    super(props)
    this.Auth = new AuthService();
    this.state = 
    {
        event_list_item: [],
        numOfEvents: 0
    }
  }

   componentDidMount() {
        const headers = {
            'Content-type': 'application/json'
        }
        const url = "https://connect-back-end.scottguo.com/api/user/events"
        if (this.Auth.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.Auth.getToken()
        }
        fetch(url, {
            method: 'GET',
            headers
            })
            .then(res => res.json())
            .catch(error => console.error('Error:', error))
            .then(async response => {
                if(response.data.events){
                    this.state.numOfEvents = Object.keys(response.data.events).length
                    this.setState({ event_list_item: response.data.events })
                    console.log(this.state.event_list_item)
                }
            });
        }
    
        render() {
            const {event_list_item, numOfEvents} = this.state;
            const { classes } = this.props;
            console.log(event_list_item);
            return (
                <div>
                <div>
                    <table>
                        <tr style={{background:'rgba(230, 70, 38, 0.95)'}}>
                            <td>Event Names</td>
                            <td>Status</td>
                        </tr>
                    {event_list_item.map(function(d, idx){
                    
                        return (
                                <tr>
                                    <td>{d.name}</td>
                                    <td>{d.status}</td>
                                </tr>
                        )
                    })}
                    </table>
                </div>
                <Divider />
                </div>
            )
        }
      
         
}

EventList.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
export default withStyles(styles)(EventList)




// WEBPACK FOOTER //
// ./src/components/Users/EventStatus.js